/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 大富翁游戏页面各配置 http://wiki.xunlei.cn/pages/viewpage.action?pageId=110357812
export const monopolyGameConfig = createAsyncThunk(
  'monopoly_game_config',
  async (p, store: any) => {
    const resp = await http.post('/live/activity/monopoly_game_config', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

// 获奖记录 http://wiki.xunlei.cn/pages/viewpage.action?pageId=110358000
export const monopolyGameRecords = createAsyncThunk(
  'monopoly_game_records',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/monopoly_game_records', {
      ...store.getState().env.deviceinfo,
      ...p,
      limit: 20,
    })
    return resp.data
  }
)

// 兑换万能骰子 http://wiki.xunlei.cn/pages/viewpage.action?pageId=110357989
export const monopolyGameExchange = createAsyncThunk(
  'monopoly_game_exchange',
  async (p, store: any) => {
    const resp = await http.post('/live/activity/monopoly_game_exchange', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)

// 单次掷骰子/掷万能骰子 http://wiki.xunlei.cn/pages/viewpage.action?pageId=110357933
export const monopolyGameThrow = createAsyncThunk(
  'monopoly_game_throw',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/monopoly_game_throw', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export type IuserRef = {
  run: (arr: number[]) => void
}

// 1: 普通单次掷骰子 2: 掷万能骰子 3: 自动掷骰子
export enum DICE_TYPE {
  normal = 1,
  gold = 2,
  auto = 3,
}

export interface IMember {
  avatar: string
  id: number
  name: string
  zy_id: string
}

export interface Record {
  name: string
  icon: string
  time?: string
  count?: number
}

export interface Result {
  msg?: string
  pos?: number // 用户位置坐标，初始值为0 运动后的坐标
  dice_point?: number // 骰子点数
  steps?: Array<number> // 格子道具加成，需要后退/或者前进的步数
  rewards?: Array<Record> // 所有奖励
}

const initialState: {
  dice: number // 骰子数量
  boxes?: Array<number> // 宝箱的位置
  select_dice: number // 万能骰子数量
  pos: number // 用户位置坐标，初始值为0
  room_id?: number // 用户的房间id
  member?: IMember
  exchange_num: number // 普通骰子兑换万能骰子的个数
  records?: Array<Record> // 奖励记录
  simple_steps?: Array<number> // 平铺的 steps [1,1,1,-1,-1]
  more: boolean
  offset: number
  game_result?: Result // 结果保存
  dice_loading?: boolean // 游戏运行中加载
  auto_loading?: boolean // 自动骰子loading
  user_loading?: boolean // 用户加载loading
  page_loading?: boolean // 页面loading
} = {
  dice: 0,
  simple_steps: [],
  select_dice: 0,
  pos: null,
  exchange_num: 0,
  records: [],
  more: true,
  offset: 0,
  game_result: {},
  dice_loading: false,
  auto_loading: false,
  user_loading: false,
  page_loading: true,
}

export const MonopolySlice = createSlice({
  name: 'Monopoly',
  initialState,
  reducers: {
    setPageLoading: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        page_loading: action.payload,
      })
    },
    setUserLoading: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        user_loading: action.payload,
      })
    },
    setAutoLoading: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        auto_loading: action.payload,
      })
    },
    setDiceLoading: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        dice_loading: action.payload,
      })
    },
    setPosition: (state, action: PayloadAction<number>) => {
      Object.assign(state, {
        pos: action.payload,
      })
    },
    setSimpleSteps: (state, action: PayloadAction<number[]>) => {
      Object.assign(state, {
        simple_steps: action.payload,
      })
    },
    setDice: (state, action: PayloadAction<number>) => {
      Object.assign(state, {
        dice: action.payload,
      })
    },
    setSelectDice: (state, action: PayloadAction<number>) => {
      Object.assign(state, {
        select_dice: action.payload,
      })
    },
    setRewards: (state, action: PayloadAction<Record[]>) => {
      Object.assign(state.game_result, {
        rewards: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(monopolyGameConfig.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      if (state.auto_loading || state.dice_loading) {
        // 进行中只更新骰子数量
        const {pos, ...ret} = data
        Object.assign(state, ret)
        return
      }
      Object.assign(state, data)
    })
    builder.addCase(monopolyGameRecords.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const {records} = state
      if (data?.offset <= 20) {
        Object.assign(state, data)
      } else {
        Object.assign(state, {...data, records: [...records, ...data.records]})
      }
    })
    builder.addCase(monopolyGameThrow.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      if (data.dice_point === 0) {
        Object.assign(state.game_result, {
          ...state.game_result,
          rewards: data?.rewards || [],
        })
      } else {
        Object.assign(state.game_result, data)
      }
    })
    builder.addCase(monopolyGameExchange.fulfilled, (state, action) => {})
  },
})

export default MonopolySlice.reducer
export const MonopolySliceActions = MonopolySlice.actions
